export default "__VITE_ASSET__BvPqDGSw__"